const TRUSTED_HOSTNAME_SUFFIXES = [
  '.picsart.com',
  '.picsart.io',
  '.picsartstage2.com',
  '.gen.ai',
];

const TRUSTED_EXACT_HOSTNAMES = [
  'picsart.com',
  'picsart.io',
  'picsartstage2.com',
  'gen.ai',
];

const tryParseUrl = (url: string | null | undefined): URL | null => {
  if (!url) return null;
  try {
    return new URL(url);
  } catch {
    return null;
  }
};

const isTrustedHostname = (hostname: string): boolean => {
  const lower = hostname.toLowerCase();
  if (TRUSTED_EXACT_HOSTNAMES.includes(lower)) return true;
  return TRUSTED_HOSTNAME_SUFFIXES.some((suffix) => lower.endsWith(suffix));
};

/** True if URL is http(s) and on a trusted Picsart hostname. */
export const isPicsartUrl = (url: string | null | undefined): boolean => {
  const parsed = tryParseUrl(url);
  if (!parsed) return false;
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return false;
  return isTrustedHostname(parsed.hostname);
};
